import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Checkbox } from '@mui/material';
import { getLabelFallback } from '@utils/utils'
import { RootState } from 'src/store/reducers';
import { FormTableHowToRead } from '@components/my-prescriptions/FormTableHowToRead';

import NotSureIcon from '@images/svg-icons/notSureEyewearPrescriptionIcon.svg';

type Props = {
    cylOD;
    cylOS;
    columns;
    formErrors;
    selectPlaceholder;
    selector;
    formValues;
    prescriptionDefaults?;
    sameForBoth;
};


const HowToReadPrescriptionEyewear = (props: Props): JSX.Element => {
    const [isButtonOdOsClicked, setIsButtonOdOsClicked] = useState(true);
    const [isButtonSphClicked, setIsButtonSphClicked] = useState(false);
    const [isButtonCylClicked, setIsButtonCylClicked] = useState(false);
    const [isButtonAxisClicked, setIsButtonAxisClicked] = useState(false);
    const [isButtonAddClicked, setIsButtonAddClicked] = useState(false);

    const [sphODHowToRead, setSphODHowToRead] = useState(0);
    const [sphOSHowToRead, setSphOSHowToRead] = useState(0);
    const [cylODHowToRead, setCylODHowToRead] = useState(0);
    const [cylOSHowToRead, setCylOSHowToRead] = useState(0);
    const [axisODHowToRead, setAxisODHowToRead] = useState(null);
    const [axisOSHowToRead, setAxisOSHowToRead] = useState(null);
    const [addODHowToRead, setAddODHowToRead] = useState(null);
    const [addOSHowToRead, setAddOSHowToRead] = useState(null);
    const [formErrorsHowToRead, setFormErrorsHowToRead] = useState({});

    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const config = useSelector((state: RootState) => state.common.config);

    const formValuesHowToRead = {
        prescription: {
            right_eye_sph: {
                value: sphODHowToRead,
                setter: setSphODHowToRead,
                hasError: formErrorsHowToRead['right_eye_sph'],
            },
            left_eye_sph: {
                value: sphOSHowToRead,
                setter: setSphOSHowToRead,
                hasError: formErrorsHowToRead['left_eye_sph'],
            },
            right_eye_cyl: {
                value: cylODHowToRead,
                setter: setCylODHowToRead,
                hasError: formErrorsHowToRead['right_eye_cyl'],
            },
            left_eye_cyl: {
                value: cylOSHowToRead,
                setter: setCylOSHowToRead,
                hasError: formErrorsHowToRead['left_eye_cyl'],
            },
            right_eye_axis: {
                value: axisODHowToRead,
                setter: setAxisODHowToRead,
                hasError: formErrorsHowToRead['right_eye_axis'],
            },
            left_eye_axis: {
                value: axisOSHowToRead,
                setter: setAxisOSHowToRead,
                hasError: formErrorsHowToRead['left_eye_axis'],
            },
            right_eye_add: {
                value: addODHowToRead,
                setter: setAddODHowToRead,
                hasError: formErrorsHowToRead['right_eye_add'],
            },
            left_eye_add: {
                value: addOSHowToRead,
                setter: setAddOSHowToRead,
                hasError: formErrorsHowToRead['left_eye_add'],
            },
        },
    };

    const handleButtonOdOsClicked = () => {
        isButtonOdOsClicked ? setIsButtonOdOsClicked(true) : setIsButtonOdOsClicked(!isButtonOdOsClicked);
        setIsButtonSphClicked(false)
        setIsButtonCylClicked(false)
        setIsButtonAxisClicked(false)
        setIsButtonAddClicked(false)
    }

    const handleButtonSphClicked = () => {
        isButtonSphClicked ? setIsButtonSphClicked(true) : setIsButtonSphClicked(!isButtonSphClicked);
        setIsButtonOdOsClicked(false)
        setIsButtonCylClicked(false)
        setIsButtonAxisClicked(false)
        setIsButtonAddClicked(false)
    }

    const handleButtonCylClicked = () => {
        isButtonCylClicked ? setIsButtonCylClicked(true) : setIsButtonCylClicked(!isButtonCylClicked);
        setIsButtonSphClicked(false)
        setIsButtonOdOsClicked(false)
        setIsButtonAxisClicked(false)
        setIsButtonAddClicked(false)
    }

    const handleButtonAxisClicked = () => {
        isButtonAxisClicked ? setIsButtonAxisClicked(true) : setIsButtonAxisClicked(!isButtonAxisClicked);
        setIsButtonSphClicked(false)
        setIsButtonCylClicked(false)
        setIsButtonOdOsClicked(false)
        setIsButtonAddClicked(false)
    }

    const handleButtonAddClicked = () => {
        isButtonAddClicked ? setIsButtonAddClicked(true) : setIsButtonAddClicked(!isButtonAddClicked);
        setIsButtonSphClicked(false)
        setIsButtonCylClicked(false)
        setIsButtonAxisClicked(false)
        setIsButtonOdOsClicked(false)
    }

    return (
        <div className= "how-to-read-espot-container-eyewear">
            {!isMobile && (
                <div className="how-to-read-espot-container-eyewear-container">
                    <span className="how-to-read-espot-container-eyewear-container-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TITLE')}</span>
                    <span className = "how-to-read-espot-container-eyewear-container-subtitle">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_SUBTITLE')}</span>
                    <div className = "how-to-read-espot-container-eyewear-container-table"> 
                        <div className="how-to-read-espot-container-eyewear-container-table-buttons">
                            <div onClick={() => handleButtonOdOsClicked()} className={`how-to-read-espot-container-eyewear-container-table-buttons-od-os ${isButtonOdOsClicked ? 'selected' : ''}`}>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_1')}</div>
                            <div onClick={() => handleButtonSphClicked()} className={`how-to-read-espot-container-eyewear-container-table-buttons-sph ${isButtonSphClicked ? 'selected' : ''}`}>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_2')}</div>
                            <div onClick={() => handleButtonCylClicked()} className={`how-to-read-espot-container-eyewear-container-table-buttons-cyl ${isButtonCylClicked ? 'selected' : ''}`}>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_3')}</div>
                            <div onClick={() => handleButtonAxisClicked()} className={`how-to-read-espot-container-eyewear-container-table-buttons-axis ${isButtonAxisClicked ? 'selected' : ''}`}>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_4')}</div>
                            <div onClick={() => handleButtonAddClicked()} className={`how-to-read-espot-container-eyewear-container-table-buttons-add ${isButtonAddClicked ? 'selected' : ''}`}>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_5')}</div>
                        </div>
                        <div className="how-to-read-espot-container-eyewear-container-table-container">
                            <div className="how-to-read-espot-container-eyewear-container-table-container-desc">
                                {isButtonOdOsClicked && (
                                    <>
                                        <div className="how-to-read-espot-container-eyewear-container-table-container-desc-text">
                                            <span className="desc-text-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_RIGHT_1')}</span>
                                            <span className="desc-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_RIGHT_1')}</span>
                                        </div>
                                        <div className="how-to-read-espot-container-eyewear-container-table-container-desc-text">
                                            <span className="desc-text-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_LEFT_1')}</span>
                                            <span className="desc-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_LEFT_1')}</span>
                                        </div>
                                    </>
                                )}

                                {isButtonSphClicked && (
                                    <>
                                        <div className="how-to-read-espot-container-eyewear-container-table-container-desc-text">
                                            <span className="desc-text-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_2')}</span>
                                            <span className="desc-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_2')}</span>
                                        </div>
                                    </>
                                )}

                                {isButtonCylClicked && (
                                    <>
                                        <div className="how-to-read-espot-container-eyewear-container-table-container-desc-text">
                                            <span className="desc-text-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_3')}</span>
                                            <span className="desc-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_3')}</span>
                                        </div>
                                    </>
                                )}

                                {isButtonAxisClicked && (
                                    <>
                                        <div className="how-to-read-espot-container-eyewear-container-table-container-desc-text">
                                            <span className="desc-text-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_4')}</span>
                                            <span className="desc-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_4')}</span>
                                        </div>
                                    </>
                                )}

                                {isButtonAddClicked && (
                                    <>
                                        <div className="how-to-read-espot-container-eyewear-container-table-container-desc-text">
                                            <span className="desc-text-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_5')}</span>
                                            <span className="desc-text">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_5')}</span>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="how-to-read-espot-container-eyewear-container-table-container-grid">
                                <div className="first-part-form frame-form">
                                    <FormTableHowToRead
                                        columns={props.columns}
                                        selector={'prescription'}
                                        cylOD={cylODHowToRead}
                                        cylOS={cylOSHowToRead}
                                        selectPlaceholder={props.selectPlaceholder}
                                        formValues={formValuesHowToRead}
                                        formErrors={props.formErrors}
                                        isButtonOdOsClicked={isButtonOdOsClicked}
                                        isButtonSphClicked={isButtonSphClicked}
                                        isButtonCylClicked={isButtonCylClicked}
                                        isButtonAxisClicked={isButtonAxisClicked}
                                        isButtonAddClicked={isButtonAddClicked}

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <span className = "how-to-read-espot-container-eyewear-container-bottom-text"> {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BOTTOMTEXT')}</span>
                    <div className = "how-to-read-espot-container-eyewear-container-not-sure"> 
                        <div className = "how-to-read-espot-container-eyewear-container-not-sure-icon">
                            <NotSureIcon />
                        </div>
                        <div className = "how-to-read-espot-container-eyewear-container-not-sure-text">
                            <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_NOTSURETEXT')}</span>
                            <span className = "underline">{config.customerServicePhoneNumber}</span>
                        </div>
                    </div>
                </div>
            )}

            {isMobile && (
                <div className="how-to-read-espot-container-eyewear-container">
                    <span className="how-to-read-espot-container-eyewear-container-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TITLE')}</span>
                    <div className="how-to-read-espot-container-eyewear-container-card-container">
                        <div className="how-to-read-espot-container-eyewear-container-card-container-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_1')}</div>
                        <div className="how-to-read-espot-container-eyewear-container-card-container-body">
                            <div className="how-to-read-espot-container-eyewear-container-card-container-body-text">
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-bold">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_RIGHT_1')}</span>
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-normal">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_RIGHT_1')}</span>
                            </div>
                            <div className="how-to-read-espot-container-eyewear-container-card-container-body-text">
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-bold">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_LEFT_1')}</span>
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-normal">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_LEFT_1')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="how-to-read-espot-container-eyewear-container-card-container">
                        <div className="how-to-read-espot-container-eyewear-container-card-container-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_2')}</div>
                        <div className="how-to-read-espot-container-eyewear-container-card-container-body">
                            <div className="how-to-read-espot-container-eyewear-container-card-container-body-text">
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-bold">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_2')}</span>
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-normal">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_2')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="how-to-read-espot-container-eyewear-container-card-container">
                        <div className="how-to-read-espot-container-eyewear-container-card-container-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_3')}</div>
                        <div className="how-to-read-espot-container-eyewear-container-card-container-body">
                            <div className="how-to-read-espot-container-eyewear-container-card-container-body-text">
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-bold">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_3')}</span>
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-normal">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_3')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="how-to-read-espot-container-eyewear-container-card-container">
                        <div className="how-to-read-espot-container-eyewear-container-card-container-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_4')}</div>
                        <div className="how-to-read-espot-container-eyewear-container-card-container-body">
                            <div className="how-to-read-espot-container-eyewear-container-card-container-body-text">
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-bold">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_4')}</span>
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-normal">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_4')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="how-to-read-espot-container-eyewear-container-card-container">
                        <div className="how-to-read-espot-container-eyewear-container-card-container-title">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BUTTON_5')}</div>
                        <div className="how-to-read-espot-container-eyewear-container-card-container-body">
                            <div className="how-to-read-espot-container-eyewear-container-card-container-body-text">
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-bold">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_TITLE_5')}</span>
                                <span className="how-to-read-espot-container-eyewear-container-card-container-body-text-normal">{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_TEXT_DESC_5')}</span>
                            </div>
                        </div>
                    </div>
                    <span className = "how-to-read-espot-container-eyewear-container-bottom-text"> {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_BOTTOMTEXT')}</span>
                    <div className = "how-to-read-espot-container-eyewear-container-not-sure"> 
                        <div className = "how-to-read-espot-container-eyewear-container-not-sure-icon">
                            <NotSureIcon />
                        </div>
                        <div className = "how-to-read-espot-container-eyewear-container-not-sure-text">
                            <span>{getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_NOTSURETEXT_MOBILE_PART_1')}</span>
                            <span>
                                {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_HOW_TO_READ_NOTSURETEXT_MOBILE_PART_2')} 
                                <span className = "underline">{config.customerServicePhoneNumber}</span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default HowToReadPrescriptionEyewear;